export default {"src":"/_next/static/media/showPass.568ae891.svg","height":18,"width":18};